import { motion } from 'framer-motion'
import { Mail, ArrowLeft } from 'lucide-react'
import type { LoginStepFormProps } from '@/components/Login/loginTypes'
import { LoginAlerts } from '@/components/Login/LoginAlerts'

export function LoginForgotPasswordForm({ flow, theme, brandColor }: LoginStepFormProps) {
  return (
    <motion.form
      key="forgotPassword"
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 20 }}
      transition={{ duration: 0.3 }}
      onSubmit={flow.handleForgotSubmit}
      className="login-form"
      style={{ display: 'flex', flexDirection: 'column', gap: 20 }}
    >
      <div className="login-field" style={{ textAlign: 'center' }}>
        <Mail size={48} style={{ color: brandColor, margin: '0 auto 16px auto', display: 'block' }} />
        <p style={{ color: theme.fontColorMuted || '#8a8a95', fontSize: '0.875rem', lineHeight: 1.6 }}>
          Digite seu e-mail para receber um link seguro de redefinição de senha.
        </p>
      </div>

      <LoginAlerts flow={flow} />

      {!flow.successMessage && (
        <div className="login-field">
          <label htmlFor="emailForgot">E-mail</label>
          <div className="login-input-wrapper" style={{ position: 'relative' }}>
            <Mail size={16} style={{ position: 'absolute', left: 14, color: theme.textMuted || '#8a8a95', zIndex: 1 }} />
            <input
              id="emailForgot"
              name="email"
              type="email"
              inputMode="email"
              autoComplete="username"
              placeholder="seu@email.com.br"
              value={flow.email}
              onChange={(e) => flow.setEmail(e.target.value)}
              required
              autoFocus
              spellCheck={false}
            />
          </div>
        </div>
      )}

      {!flow.successMessage && (
        <button
          type="submit"
          className="login-submit"
          disabled={flow.isAnyPending || !flow.email}
          style={{
            background: brandColor,
            boxShadow: `0 4px 15px ${brandColor}4D`,
            opacity: flow.isAnyPending || !flow.email ? 0.5 : 1,
          }}
        >
          {flow.isAnyPending ? <span className="login-spinner" /> : 'Enviar link'}
        </button>
      )}

      <button type="button" onClick={flow.goBack} className="login-back-btn">
        <ArrowLeft size={14} /> Voltar ao Login
      </button>
    </motion.form>
  )
}
